import { t, accentUserLang } from '../HelperService';

/** A 5th-week start (day 29-31), or stored "-1", is treated as "last". */
export const getOrdinal = (n) => {
    if (n === -1 || n >= 5) return t("application_strings.views.calendar.ordinal_last") || "Last";
    return t(`application_strings.views.calendar.ordinal_${n}`) || `${n}th`;
};

/** Occurrence of this date's weekday in its month: 1–4, or -1 for last (5th week). */
export const getWeekdayOccurrence = (date) => {
    if (!date) return null;
    const ordinal = Math.ceil(date.getDate() / 7);
    return ordinal >= 5 ? -1 : ordinal;
};

/** 0-based month. Returns null if the nth weekday does not exist in that month. */
export const getNthWeekdayOfMonth = (year, month, dayOfWeek, nth) => {
    if (nth === -1) return getLastWeekdayOfMonth(year, month, dayOfWeek);

    let count = 0;
    const dim = new Date(year, month + 1, 0).getDate();
    for (let day = 1; day <= dim; day++) {
        const dt = new Date(year, month, day);
        if (dt.getDay() !== dayOfWeek) continue;
        count += 1;
        if (count === nth) return dt;
    }
    return null;
};

/** 0-based month. */
export const getLastWeekdayOfMonth = (year, month, dayOfWeek) => {
    const lastDay = new Date(year, month + 1, 0);
    const daysBack = (7 + lastDay.getDay() - dayOfWeek) % 7;
    return new Date(year, month, lastDay.getDate() - daysBack);
};

/** Ordinal 5 (start day 29–31) means last weekday of month so short months still get a date. */
export const getWeekdayOccurrenceInMonth = (start, year, month) => {
    const ordinal = Math.ceil(start.getDate() / 7);
    if (ordinal >= 5) return getLastWeekdayOfMonth(year, month, start.getDay());
    return getNthWeekdayOfMonth(year, month, start.getDay(), ordinal);
};

export const getRecurrenceMonthlyPatternDescriptions = (startDate, repeatUnit) => {
    if (!startDate) {
        return {
            dayOfMonth: t("application_strings.views.calendar.recurrenceByDayOfMonth"),
            weekday: t("application_strings.views.calendar.recurrenceByWeekday"),
        };
    }
    const d = new Date(startDate);
    const day = d.getDate();
    const weekOrdinalInMonth = Math.ceil(day / 7);
    const ordinal = getOrdinal(weekOrdinalInMonth);
    const locale = accentUserLang || "en-AU";
    const weekday = new Intl.DateTimeFormat(locale, { weekday: "long" }).format(d);
    const month = new Intl.DateTimeFormat(locale, { month: "long" }).format(d);
    const isYear = repeatUnit === "repeatUnit_year";
    return {
        dayOfMonth: isYear
            ? t("application_strings.views.calendar.recurrenceOnDay_year", { month, day })
            : t("application_strings.views.calendar.recurrenceOnDay_month", { day }),
        weekday: isYear
            ? t("application_strings.views.calendar.recurrenceOnWeekday_year", { ordinal, weekday, month })
            : t("application_strings.views.calendar.recurrenceOnWeekday_month", { ordinal, weekday }),
    };
};
